// i18n (A11): pt-BR only for now, strings externalised in src/locales.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ptBR } from './locales/pt-BR.ts';

export const i18nReady = i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  resources: { 'pt-BR': { translation: ptBR } },
  interpolation: { escapeValue: false }, // React escapes
  returnNull: false,
});

export default i18n;
